

 const config = {

}

let otherconfig = require('@/config.js');
if(otherconfig!=null){
  for(var x in otherconfig){
    config[x] = otherconfig[x];
  }
}
module.exports = config;